import { Component } from "react";
import type { ReactNode, ErrorInfo } from "react";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import {
  ThemeProvider,
  StyledEngineProvider,
  createTheme,
} from "@mui/material/styles";
import { apm } from "@/shared/utils/apm";
import { PRIMARY_MAIN } from "@/shared/utils/createTheme";

const theme = createTheme({
  palette: {
    mode: (localStorage.getItem("theme") as "light" | "dark") || "dark",
    primary: {
      main: PRIMARY_MAIN,
    },
  },
});

const Root = styled("div")({
  top: 0,
  right: 0,
  left: 0,
  bottom: 0,
  position: "absolute",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
});

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

export class ErrorMonitoring extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { error: null };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState({ error });

    apm?.captureError(error);

    console.log("ErrorMonitoring", { error, errorInfo });
  }

  render() {
    if (this.state.error) {
      return (
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={theme}>
            <Root>
              <Grid container spacing={4} sx={{ maxWidth: 480, width: "100%" }}>
                <Grid size={12}>
                  <Typography variant="h4" align="center" color="textPrimary">
                    Something went wrong
                  </Typography>
                </Grid>
                <Grid size={12}>
                  <Typography
                    variant="subtitle1"
                    align="center"
                    color="textSecondary"
                  >
                    The developers received a message about this error and
                    promise fix everything soon.
                  </Typography>
                </Grid>
                <Grid size={12}>
                  <Button
                    disableElevation
                    color="primary"
                    variant="contained"
                    size="large"
                    onClick={() => {
                      window.location.reload();
                    }}
                  >
                    Reload page
                  </Button>
                </Grid>
              </Grid>
            </Root>
          </ThemeProvider>
        </StyledEngineProvider>
      );
    } else {
      return this.props.children;
    }
  }
}
